import { render, staticRenderFns } from "./ModalRoot.vue?vue&type=template&id=4210654f&scoped=true&"
import script from "./ModalRoot.vue?vue&type=script&lang=js&"
export * from "./ModalRoot.vue?vue&type=script&lang=js&"
import style0 from "./ModalRoot.vue?vue&type=style&index=0&id=4210654f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4210654f",
  null
  
)

export default component.exports